import React, { useState } from "react"
import { connect } from "react-redux"
import { WP_ACTIONS } from "./store"

import * as clearview from "../../../../components/@Clearview"

import FileUploadButton, { excelSheetReader } from "../../Workflows/components/FileUploadButton"
import { SimpleTable } from "../../../../components"
import { AddUpdateCrsDrs } from "./components"

function DRsAndPrepayPage({ isReadOnly, drsAndPrepay, onDelete, onSave, onReadWorksheet }) {
	const [rowEditor, setRowEditor] = useState(false)

	const onAdd = isReadOnly
		? false
		: defaultValue => {
				setRowEditor({ title: "Add New Dr/Prepay", value: { schedule: defaultValue.schedule, code: undefined, total: 0 } })
		  }

	const onEdit = isReadOnly
		? false
		: row => {
				setRowEditor({ title: "Edit Dr/Prepay", value: { ...row } })
		  }

	if (isReadOnly) onDelete = false

	const onCancel = e => {
		setRowEditor(false)
	}

	const columns = {
		// schedule: { map: clearview.tidy.string },
		date: { map: clearview.tidy.date, className: "nowrap" },
		code: { map: (col, row) => clearview.tidy.string(row.nominalCode?.code) },
		account: { map: (col, row) => clearview.tidy.string(row.nominalCode?.name), className: "nowrap" },
		reference: { heading: "BW Ref", map: clearview.tidy.string },
		total: {
			map: clearview.tidy.currency,
			className: "currency text-dark",
		},
		supplier: { map: clearview.tidy.string },
		comments: { map: clearview.tidy.string },
	}

	return (
		<React.Fragment>
			<div className="mt-2">
				<SimpleTable
					columns={columns}
					data={drsAndPrepay}
					groupBy={["schedule"]}
					summaryColumns={["total"]}
					onAdd={onAdd}
					onEdit={onEdit}
					onDelete={onDelete}
				/>
			</div>
			<AddUpdateCrsDrs
				name="rowEditor"
				config={{ title: rowEditor?.title }}
				isOpen={!!rowEditor}
				onCancel={onCancel}
				onSave={row => {
					onSave(row)
					onCancel()
				}}
				value={rowEditor?.value}
			/>
			{!isReadOnly && (
				<FileUploadButton className="mt-2" onUploaded={excelSheetReader(onReadWorksheet)} accept=".xls,.xlsx,.csv">
					{clearview.Icon.upload} Import DRs and Prepay...
				</FileUploadButton>
			)}
		</React.Fragment>
	)
}

const mapStateToProps = state => {
	return {
		drsAndPrepay: state.workingPapersReducer.workingPapers.drsAndPrepay,
	}
}

const mapDispatchToProps = dispatch => ({
	onDelete: row =>
		dispatch({
			type: WP_ACTIONS.DELETE_ROW,
			page: "drsAndPrepay",
			row,
		}),

	onSave: row =>
		dispatch({
			type: WP_ACTIONS.SAVE_ROW,
			page: "drsAndPrepay",
			row,
		}),

	onReadWorksheet: (file, data, worksheetName) =>
		dispatch({
			type: WP_ACTIONS.READ_DRS_AND_PREPAY_WORKSHEET,
			page: "drsAndPrepay",
			data,
		}),
})

export default connect(mapStateToProps, mapDispatchToProps)(DRsAndPrepayPage)
